import BaseAPIService from "./BaseAPIService";
import gql from "graphql-tag";

export default class ExperienceService extends BaseAPIService {
  constructor() {
    super();
  }

  getExperiencesByUser(userId, args) {
    return new Promise((resolve, reject) => {
      const { limit } = args;
      const query = gql`
            query experiencesOfUser($userId: ID!, $limit: Int) {
                experiencesOfUser(userId: $userId${
                  argsString ? `, ${argsString}` : ""
                }) {
                    data {
                        id
                        title
                        name
                        thumbnailUrl
                    }
                    final
                }
              }
            `;
      const variables = {
        userId,
        limit: limit || 1000,
      };
      this.query({ query, variables })
        .then((result) => {
          const returnData = result.data.experiencesOfUser;
          resolve(returnData);
        })
        .catch(reject);
    });
  }

  getExperience(id) {
    return new Promise((resolve, reject) => {
      const query = require("../graphql/queries/experience.gql");
      const variables = { id };
      this.query({ query, variables, fetchPolicy: "network-only" })
        .then((result) => {
          const returnData = result.data.experience;
          resolve(returnData);
        })
        .catch(reject);
    });
  }

  openMap(key) {
    console.log(key);
    return key;
  }

  createExperience(input) {
    return new Promise((resolve, reject) => {
      if (input.position && input.position.latitude) {
        input.position.latitude = parseFloat(input.position.latitude);
      }

      if (input.position && input.position.longitude) {
        input.position.longitude = parseFloat(input.position.longitude);
      }

      delete input.id;

      const mutation = gql`
        mutation createExperience($input: ExperienceInput!) {
          createExperience(input: $input) {
            id
          }
        }
      `;
      const variables = { input };
      this.mutate({ mutation, variables })
        .then((result) => {
          const returnData = result.data.createExperience;
          resolve(returnData);
        })
        .catch(reject);
    });
  }

  updateExperience(input) {
    return new Promise((resolve, reject) => {
      const mutation = gql`
        mutation updateExperience($id: ID!, $input: ExperienceInput!) {
          updateExperience(id: $id, input: $input) {
            id
          }
        }
      `;
      const id = input.id;
      delete input.id;
      const variables = {
        id,
        input,
      };
      this.mutate({ mutation, variables })
        .then((result) => {
          const returnData = result.data.updateExperience;
          resolve(returnData);
        })
        .catch(reject);
    });
  }

  deleteExperience(id) {
    return new Promise((resolve, reject) => {
      const mutation = gql`
        mutation deleteExperience($id: ID!) {
          deleteExperience(id: $id)
        }
      `;
      const variables = { id };
      this.mutate({ mutation, variables })
        .then(() => {
          resolve();
        })
        .catch(reject);
    });
  }

  async getExperienceAffiliationApproval(id) {
    const query = require("../graphql/queries/experienceAffiliationApproval.gql");
    const variables = { id };
    const options = {
      query,
      variables,
    };
    const res = await this.query(options);
    return res.data.experienceAffiliationApproval;
  }

  async updateExperienceAffiliationApprovalStatus(id, status) {
    const mutation = require("../graphql/mutations/updateExperienceAffiliationApprovalStatus.gql");
    const variables = { id, status };
    const options = {
      mutation,
      variables,
    };
    const res = await this.mutate(options);
    return res.data.updateExperienceAffiliationApprovalStatus;
  }

  async getExperienceAffiliations(variables) {
    const query = require("../graphql/queries/experienceAffiliations.gql");
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.experienceAffiliations;
  }

  async requestExperienceAffiliationApproval(variables) {
    const mutation = require("../graphql/mutations/requestExperienceAffiliationApproval.gql");
    const options = {
      mutation,
      variables,
    };
    const res = await this.mutate(options);
    return res.data.requestExperienceAffiliationApproval;
  }

  async getExperienceAffiliationApprovalByContentId(contentId) {
    const query = require("../graphql/queries/experienceAffiliationApprovalByContentId.gql");
    const variables = { contentId };
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.experienceAffiliationApprovalByContentId;
  }

  async getJoinableExperiences(variables) {
    const query = require("../graphql/queries/joinableExperiences.gql");
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.joinableExperiences;
  }

  async getPlatformContentApproval(id) {
    const query = require("../graphql/queries/experienceContentApproval.gql");
    const variables = { id };
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.experienceContentApproval;
  }

  async getExperienceContentApprovalByContentId(contentId) {
    const query = require("../graphql/queries/experienceContentApprovalByContentId.gql");
    const variables = { contentId };
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.experienceContentApprovalByContentId;
  }

  async updateExperienceContentApprovalStatus(id, status) {
    const mutation = require("../graphql/mutations/updateExperienceContentApprovalStatus.gql");
    const variables = { id, status };
    const options = {
      mutation,
      variables,
    };
    const res = await this.mutate(options);
    return res.data.updateExperienceContentApprovalStatus;
  }

  async getSuggestedExperiences(search) {
    const query = require("../graphql/queries/suggestedExperiences.gql");
    const variables = { search };
    const options = {
      query,
      variables,
      fetchPolicy: "network-only",
    };
    const res = await this.query(options);
    return res.data.suggestedExperiences;
  }

  async claimExperience(id, input) {
    const mutation = require("../graphql/mutations/claimExperience.gql");
    const variables = { id, input };
    const options = {
      mutation,
      variables,
    };
    const res = await this.mutate(options);
    return res.data.claimExperience;
  }
}
